export default "https://assets.egbcdn.net/assets/packs/_/images/svg_icons/image-clash-casino-cb4ccd99d24899cc599b193db25ecd63.svg";